import { memo } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { RedirectContainer } from '~src/styles/shared.sc';
import { routes } from '~src/routingConfig';
import { SubHeader, RedirectContentWrapper, LinkContainer, MainHeader } from '~src/modules/okrs/objectivesStream/shared.sc';
import NavArrowLnk from '~src/shared/buttons/NavArrowLnk';
import { white } from '~src/styles/colors/index';
import group from '~src/images/group.png';

export const NoObjectiveMessageContainer = styled.div`
  width: 540px;
  padding-top: 60px;
`;

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 30px;
`;

type Props = RouteComponentProps<any>;

const NoObjective = memo((props: Props) => {
  const [t] = useTranslation();
  const handleClick = () => {
    props.history.push(routes.okrs.list);
  };

  return (
    <RedirectContainer>
      <RedirectContentWrapper $height={'auto'} $redirect={false}>
        <NoObjectiveMessageContainer>
          <img src={group} height={160} />
          <InfoContainer>
            <MainHeader>{t('x.okr.update_stream.objective_updated.all_set')}</MainHeader>
            <SubHeader>{t('x.okr.update_stream.objective_updated.no_objective')}</SubHeader>
            <LinkContainer onClick={handleClick}>
              <NavArrowLnk arrOnRight arrowDir="right" color={white.a10}>
                {t('x.okr.update_stream.objective_updated.objective_overview')}{' '}
              </NavArrowLnk>
            </LinkContainer>
          </InfoContainer>
        </NoObjectiveMessageContainer>
      </RedirectContentWrapper>
    </RedirectContainer>
  );
});

const NoObjectiveSuper = withRouter(NoObjective);

export default NoObjectiveSuper;
